import { DateObjectType } from '@typings/common';
import dayjs from 'dayjs';
// eslint-disable-next-line import/no-cycle
import { NextOfKinDetailsType } from './components/NextOfKinDetails';

const validateDobMessage = (date: DateObjectType) => {
  if (!date.day || !date.month || !date.year) {
    return "Enter the person's date of birth";
  }
  if (date.day && date.month && date.year) {
    const paddedDate = `${String(date.year).padStart(4, '0')}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;

    const isValidDate = dayjs(paddedDate, 'YYYY-MM-DD', true).isValid();

    if (!isValidDate) {
      return 'Please enter a valid date of birth';
    }
    const currentDate = dayjs().startOf('day');
    const enteredDate = dayjs(paddedDate, 'YYYY-MM-DD');
    if (!enteredDate.isBefore(currentDate)) {
      return 'Please enter a date of birth in the past';
    }
  }
  return '';
};

const haveNextOfKinOptions = [
  {
    value: 'yes',
    label: 'Yes',
  },
  { value: 'no', label: 'No' },
];

const haveLpaOptions = [
  {
    value: 'yes',
    label: 'Yes',
  },
  { value: 'no', label: 'No' },
  { value: 'notSure', label: 'Not Sure' },
];

const nokStatusMap = {
  yes: true,
  no: false,
};

const resetNextOfKinDetails = (data: NextOfKinDetailsType) => {
  if (data.nextOfKinStatus === 'no') {
    return {
      ...data,
      nfkFullName: '',
      nfkPhoneNumber: '',
      nfkRelationship: '',
      haveLPA: '',
    };
  }
  return data;
};

export {
  validateDobMessage,
  haveNextOfKinOptions,
  haveLpaOptions,
  nokStatusMap,
  resetNextOfKinDetails,
};
